var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text"},domProps:{"value":_vm.format(_vm.value)},on:{"input":function($event){return _vm.parse($event.target.value)},"keypress":function($event){return _vm.isNumber($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }